import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step7 } from '../../../../../shared/models/component-messages/mapaIN/step7';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Initial } from '../../models/Initial';

@Component({
  selector: 'app-step7',
  templateUrl: './step7.component.html'
})
export class Step7Component implements OnInit {

  private LOG: LogService = new LogService(Step7Component);

	@Input() initial: Initial;

	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	

	@Input() uid = '';


	public step7 = new Step7();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
	) { }


  ngOnInit(): void {}

  public getUid() {
		return this.uid;
	}

}
